import React from 'react'
import './ITSError.scss'

export const ITSError: React.FunctionComponent<{ errorMessage: string }> = props => (
  <div data-component="itserror-component">
    <div className="alert alert-danger">{props.errorMessage}</div>
  </div>
)
